<script setup lang="ts">
import { ref, watch } from 'vue'
import type { SectionHeroRecord } from '~/types/datocms'
import { useMouseInElement } from '@vueuse/core'

const props = defineProps<{
  data: SectionHeroRecord
  moduleIndex: number
}>()

const { level, isSemantic } = useSectionRules(props.moduleIndex, true)

const appStore = useAppStore()
const { emitterEmit } = useEmitter()
const videoBlockRef = ref<HTMLElement | null>(null)
const { isOutside } = useMouseInElement(videoBlockRef)

let triggeredOnce = false

watch(isOutside, (outside) => {
  if (!outside && !triggeredOnce) {
    triggeredOnce = true
    emitterEmit('hotspotEnter', {
      label: 'Play showreel',
      iconLeft: 'custom:play-small'
    })
  }
})

onBeforeUnmount(() => {
  emitterEmit('hotspotLeave')
})

onMounted(() => {
  appStore.setTheme('light')
  appStore.setGradientHeader('black')
})
</script>

<template>
  <section ref="videoBlockRef" class="relative overflow-hidden">
    <Heading :level="level" :is-semantic="isSemantic" class="sr-only hidden text-5xl"
      >Pakt media</Heading
    >
    <VideoBlock
      class="w-full cursor-none lg:min-h-dvh"
      :data="data.video"
      @mouseover="
        emitterEmit('hotspotEnter', {
          label: 'Play showreel',
          iconLeft: 'custom:play-small'
        })
      "
      @mouseleave="emitterEmit('hotspotLeave')"
    />
    <div
      class="pointer-events-none absolute bottom-4 left-4 z-2 flex h-10 items-center gap-4 whitespace-nowrap rounded-full bg-black/60 px-4 uppercase text-yellow backdrop-blur-sm lg:hidden"
    >
      <Icon name="custom:play-small" :size="16" />
      Play showreel
    </div>
  </section>
</template>
